import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=407f36bc&scoped=true&"
import script from "./MainPage.ts?vue&type=script&lang=ts&"
export * from "./MainPage.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407f36bc",
  null
  
)

export default component.exports